import { render, staticRenderFns } from "./BriefTrainingReport.vue?vue&type=template&id=1ee74e4e&scoped=true"
import script from "./BriefTrainingReport.vue?vue&type=script&lang=js"
export * from "./BriefTrainingReport.vue?vue&type=script&lang=js"
import style0 from "./BriefTrainingReport.vue?vue&type=style&index=0&id=1ee74e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee74e4e",
  null
  
)

export default component.exports